import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import Monogram from "./Monogram";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProtectedRoute({ children }) {
  const { user, setUser } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState(
    user || location.state?.user ? "ok" : "checking"
  );

  useEffect(() => {
    if (status !== "checking") return;
    let cancelled = false;
    // Server-side session verification — the source of truth.
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => {
        if (cancelled) return;
        setUser(res.data);
        setStatus("ok");
      })
      .catch(() => {
        if (!cancelled) setStatus("denied");
      });
    return () => {
      cancelled = true;
    };
  }, [status, setUser]);

  if (status === "checking") {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen bg-ink text-ivory font-body flex flex-col items-center justify-center gap-5"
      >
        <Monogram className="w-14 h-14 text-gold animate-pulse" />
        <p className="flex items-center gap-2 text-sm text-ivory-dim">
          <Loader2 className="w-4 h-4 animate-spin text-gold" />
          Checking your session…
        </p>
      </div>
    );
  }

  if (status === "denied") return <Navigate to="/login" replace />;

  return children;
}
